import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_HALAL_STOCK_BULK_TEMPLATE } from "../../../config/api";

export const downloadStockTemplate = createAsyncThunk(
  "stocks/downloadTemplate",
  async (args, { rejectWithValue }) => {
    const { callback, failed } = args || {};
    try {
      const response = await Client({
        method: "GET",
        path: API_HALAL_STOCK_BULK_TEMPLATE,
      });

      const { download_url, file_name } = response?.data?.data || {};

      if (!download_url) {
        throw new Error("Template download URL was not provided.");
      }

      const link = document.createElement("a");
      link.href = download_url;
      link.setAttribute("download", file_name || "");
      link.setAttribute("target", "_blank");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Template downloaded successfully");
      callback && callback();

      return true;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed && failed();
      return rejectWithValue(error.message);
    }
  }
);
